import React from 'react'
import './get-notified.css';
import { ReactComponent as HexagonIcon } from '../../../assets/icons/hexagon.svg';
import { ReactComponent as CheckIconCircle } from '../../../assets/icons/check-circle.svg';

function RegistrationSuccess() {
    return (
        <div className='registration-success'>
            <div className="registration-success-icon">
                <HexagonIcon />
                <CheckIconCircle className='check-circle' />
            </div>
            <h5>Thank you for registering!</h5>
            <p>We’re expanding our services and will notify you as soon as we’re available in your area. Stay tuned!.</p>
            <button id='back-to-home'>
                Back to home
            </button>
        </div>
    )
}

export default RegistrationSuccess